module.exports = __webpack_public_path__ + "assets/icon-fav-selected.bcea491d.svg";